export const INITIAL_NOTIFICATIONS_RECEIVED = "INITIAL_NOTIFICATIONS_RECEIVED";
export const NOTIFICATION_BATCH_RECEIVED = "NOTIFICATION_BATCH_RECEIVED";
